<template>
  <div
    ref="timelineRoot"
    class="service-visits-calendar-timeline overflow-auto border rounded"
    :class="{ 'service-visits-calendar-timeline--page-scroll': fullscreen }"
  >
    <div
      class="service-visits-calendar-timeline__days"
      :style="calendarGridStyle"
    >
      <div
        v-for="day in days"
        :key="day.date"
        class="service-visits-calendar-timeline__day-header text-center border-right border-bottom py-3 bg-white"
        :class="{
          'service-visits-calendar-timeline__day-header--weekend': day.isWeekend,
          'service-visits-calendar-timeline__day-header--today': day.isToday
        }"
      >
        <strong class="d-block text-dark">{{ day.day }}</strong>
        <small>{{ day.weekday }}</small>
      </div>
    </div>

    <div
      class="service-visits-calendar-timeline__body position-relative"
      :style="calendarBodyStyle"
    >
      <div
        v-for="(day, index) in days"
        :key="`cell-${day.date}`"
        class="service-visits-calendar-timeline__day-cell border-right"
        :class="{ 'service-visits-calendar-timeline__day-cell--weekend': day.isWeekend }"
        :style="dayCellStyle(index)"
      ></div>

      <ServiceVisitsCalendarBar
        v-for="bar in bars"
        :key="bar.visit.id"
        :bar="bar"
      />

    </div>
  </div>
</template>

<script>
import ServiceVisitsCalendarBar from "@/modules/service-visits/components/ServiceVisitsCalendarBar.vue";

export default {
  name: "ServiceVisitsCalendarTimeline",
  components: {
    ServiceVisitsCalendarBar
  },
  props: {
    days: {
      type: Array,
      required: true
    },
    bars: {
      type: Array,
      required: true
    },
    calendarGridStyle: {
      type: Object,
      required: true
    },
    calendarBodyStyle: {
      type: Object,
      required: true
    },
    bodyRowCount: {
      type: Number,
      required: true
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    dayCellStyle(index) {
      return {
        gridColumn: `${index + 1} / span 1`,
        gridRow: `1 / span ${this.bodyRowCount}`
      };
    },
    scrollToCurrentDate(behavior = "auto") {
      const todayIndex = this.days.findIndex(day => day.isToday);

      if (todayIndex === -1) {
        return;
      }

      this.$nextTick(() => {
        const root = this.$refs.timelineRoot;

        if (!root) {
          return;
        }

        const dayHeader = root.querySelectorAll(
          ".service-visits-calendar-timeline__day-header"
        )[todayIndex];
        const scrollContainer = this.fullscreen
          ? root.closest(".service-fullscreen-scroll")
          : root;

        if (!dayHeader || !scrollContainer) {
          return;
        }

        const dayRect = dayHeader.getBoundingClientRect();
        const containerRect = scrollContainer.getBoundingClientRect();
        const nextScrollLeft = Math.max(
          0,
          scrollContainer.scrollLeft + dayRect.left - containerRect.left
        );

        scrollContainer.scrollTo({
          left: nextScrollLeft,
          behavior
        });
      });
    }
  }
};
</script>

<style scoped>
.service-visits-calendar-timeline__days,
.service-visits-calendar-timeline__body {
  display: grid;
  min-width: max-content;
}

.service-visits-calendar-timeline__day-header {
  min-width: 96px;
}

.service-visits-calendar-timeline__day-header--weekend {
  background: #f7f8fa !important;
}

.service-visits-calendar-timeline__day-header--today {
  box-shadow: inset 0 -3px 0 #3699ff;
}

.service-visits-calendar-timeline__body {
  background:
    repeating-linear-gradient(
      to bottom,
      #ffffff 0,
      #ffffff 45px,
      #f1f3f7 45px,
      #f1f3f7 46px
    );
}

.service-visits-calendar-timeline__day-cell {
  background: transparent;
  min-width: 96px;
}

.service-visits-calendar-timeline__day-cell--weekend {
  background: rgba(247, 248, 250, 0.82);
}

.service-visits-calendar-timeline--page-scroll {
  min-width: max-content;
  overflow: visible !important;
  width: max-content;
}

.service-visits-calendar-timeline--page-scroll
  .service-visits-calendar-timeline__days,
.service-visits-calendar-timeline--page-scroll
  .service-visits-calendar-timeline__body {
  width: max-content;
}
</style>
